import {getTargetContainers, getTargetContainerSyncHandler} from '../utility/target-sync';

const COMPONENT_NAME = "tab-container";
const CLASS_SELECTOR = ".TabContainer";
const TAB_SELECTOR = ".Tab";
const DROPDOWN_SELECTOR = ".TabContainer-dropdown";
const ATTRIBUTE_CONTENT = "data-tab-content";
const TAB_CONTENT_SELECTOR = `.TabContent,[${ATTRIBUTE_CONTENT}]`;

const ACTIVE_CLASS = "is-active";

const instances = [];

function initialize(element, PageComponents) {
    if (element.classList.contains('is-standalone')) return;

    const targetSelector = element.getAttribute("data-target");
    const tabElements = element.querySelectorAll(TAB_SELECTOR);
    const contentElementList = getTargetContainers(targetSelector, TAB_CONTENT_SELECTOR, tabElements);
    if (contentElementList.length < 1) {
        console.error(`Error: could not find content target "${targetSelector}" for tab container`, element);
        return;
    }

    const dropdownElement = element.querySelector(DROPDOWN_SELECTOR);
    let activeTabIndex = -1;

    const tabs = [];
    //const options = [];

    function syncTabs(index) {
        tabElements.forEach((tab, i) => {
            tab.classList.toggle(ACTIVE_CLASS, i === index);
        });
    }
    function syncDropdown(index) {
        if( dropdownElement ) {
            dropdownElement.selectedIndex = index;
        }
    }
    const syncContent = getTargetContainerSyncHandler(contentElementList, ACTIVE_CLASS);

    function sync(index) {
        if( index < 0 || index >= tabElements.length ) {
            return;
        }
        syncTabs(index);
        syncContent(index);
        syncDropdown(index);
        activeTabIndex = index;
    }

    function getIndexByTargetName(targetName) {
        if ( contentElementList.length < 1 ) {
            console.warn( `Warning: No content elements found for target name: ${targetName}` );
            return -1;
        }
        const contents = contentElementList[0];
        return Array.from(contents).findIndex((content) => {
            return (
                content.getAttribute('data-tab-content') === targetName ||
                content.id === targetName
            );
        });
    }

    function getIndexByTabElement(tabElement) {
        return tabElements.indexOf(tabElement);
    }

    const api = {
        element,
        sync,
        tabs: tabElements,
        contents: contentElementList,
        get activeIndex() {
            return activeTabIndex;
        },
        goTo(index) {
            sync(Number(index));
        },
        next() {
            if (activeTabIndex < tabElements.length - 1) {
                sync(activeTabIndex + 1);
            }
        },
        prev() {
            if (activeTabIndex > 0) {
                sync(activeTabIndex - 1);
            }
        },
        goToTarget(targetName) {
            const index = getIndexByTargetName(targetName);
            if (index > -1) sync(index);
        }
    };

    tabElements.forEach((tab, index) => {
        if (tab.classList.contains(ACTIVE_CLASS)) {
            activeTabIndex = index;
        }

        // Create dropdown option
        if ( dropdownElement ) {
            const option = document.createElement("option");
            option.value = index;
            option.text = tab.innerText;
            dropdownElement.appendChild(option);
            //options.push(option);
        }

        // Add desktop tab click handler
        tab.addEventListener('click', (e) => {
            e.preventDefault(); // prevent potential hash change if tabs are links OR form submissions if tabs are buttons
            e.stopPropagation();
            sync(index);
        });
    });

    if (activeTabIndex === -1 && tabElements.length) {
        activeTabIndex = 0;
    }

    sync(activeTabIndex);

    // Dropdown change handler
    if( dropdownElement ) {
        dropdownElement.addEventListener('change', (e) => {
            e.stopPropagation();
            sync(dropdownElement.selectedIndex);
        });
    }

    element.tabContainer = api;

    instances.push( api );
}

document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) return;

    const tabContainerSelector = trigger.getAttribute('data-tab-trigger');
    const tabContainerElement = document.querySelector(tabContainerSelector);

    if (!tabContainerElement || !tabContainerElement.tabContainer) return;

    event.preventDefault();

    const tabIndex = trigger.getAttribute('data-tab-index');
    const tabTarget = trigger.getAttribute('data-tab-target');

    if (tabIndex !== null) {
        tabContainerElement.tabContainer.goTo(tabIndex);
        return;
    }

    if (tabTarget) {
        tabContainerElement.tabContainer.goToTarget(tabTarget);
    }

    if( trigger.getAttribute('data-tab-scroll') ) {
        tabContainerElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
});

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
